module.exports = __webpack_public_path__ + "static/media/07B.3639edd7.png";